<script setup>
import { ChevronDown, } from 'lucide-vue-next';
import { SelectIcon, SelectTrigger, useForwardProps, } from 'radix-vue';
import { computed, } from 'vue';
import { cn, } from '@/utils/ShadcnUtil';
import { selectTriggerVariants, selectIconVariants, } from '~/components/ui/select/index';
import { Button, } from '~/components/ui/button';

const props = defineProps({
  disabled: { type: Boolean, required: false },
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false },
  class: { type: null, required: false },
  variant: { type: String, required: false, default: 'default' },
  selectIcon: { type: String, required: false, default: 'chevron-down' },
  selectIconVariant: { type: String, required: false },
});

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props;

  return delegated;
});

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <SelectTrigger
    initial-focus
    v-bind="forwardedProps"
    :class="
      cn(selectTriggerVariants({ intent: props.variant }), props.class)
    "
  >
    <slot />
    <SelectIcon
      as-child
      :class="
        cn(selectIconVariants({ intent: props.variant }), props.class)
      "
    >
      <t-icon
        :name="selectIcon"
      />
    </SelectIcon>
  </SelectTrigger>
</template>
